import { VersionsScreen } from './VersionsScreen';

export const versionsRoute = { path: 'versions', element: <VersionsScreen /> };
